import { render } from "./GetSystemModules.vue?vue&type=template&id=45a57440&scoped=true"
import script from "./GetSystemModules.vue?vue&type=script&lang=js"
export * from "./GetSystemModules.vue?vue&type=script&lang=js"

import "./GetSystemModules.vue?vue&type=style&index=0&id=45a57440&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a57440"]])

export default __exports__